import { apiRequest } from "../general.service";
import v1Service from "../v1.service"
const myService = {
    path: `${v1Service.basic}/${v1Service.user.my}`,
    methods: {
        getPath: (new_path: string): string => {
            return myService.path + new_path
        },
        info: () => {
            console.log("get my infoooooo")
            return apiRequest<API.APIResponse<API.UserProfile>>(myService.methods.getPath("/"), "GET")
        },
        avatar: () => {
            return apiRequest<API.APIResponse<API.UserAvatar>>(myService.methods.getPath("/avatar"), "GET")
        },
        resetPassword: (body: API.ResetPasswordDto) => {
            return apiRequest<API.APIResponse<API.UserIdDto>>(myService.methods.getPath("/resetPassword"), "POST", body)
        }, 
        updateProfile: (body: API.UpdateMyProfileDto) => {
            return apiRequest<API.APIResponse<API.UserIdDto>>(myService.methods.getPath("/updateProfile"), "POST", body)
        },
    }
};
export default myService;

